class UpdateSubscriptionModalController {
  constructor($scope, $uibModalInstance, subscriptionPatch) {
    $scope.subscriptionPatch = subscriptionPatch
    const initialSubPlan = subscriptionPatch.plan
    const initialSubCoverage = _.clone(subscriptionPatch.coverage)

    $scope.subscriptionChanged = function() {
      var planDifferent = initialSubPlan !== $scope.subscriptionPatch.plan
      var addOnsDifferent = !(_.isEqual(
          initialSubCoverage, $scope.subscriptionPatch.coverage))
      return planDifferent || addOnsDifferent
    }

    $scope.atLeastOne = function() {
        const coverage = _($scope.subscriptionPatch.coverage)
          .pick((val, key) => val === true)
          .keys()
          .value()
        return coverage.length < 1
    }


    $scope.accept = function() {
      $uibModalInstance.close($scope.subscriptionPatch)
    }

    $scope.cancel = function() {
      $uibModalInstance.dismiss('cancel')
    }
  }
}

UpdateSubscriptionModalController.$inject = [
  '$scope',
  '$uibModalInstance',
  'subscriptionPatch'
]

export default UpdateSubscriptionModalController
